export default __webpack_public_path__ + "static/media/home-events-conference-img-16.b8213acd.jpg";